import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function walletAddressHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'walletAddressHeader',
    baseStyle: {},
    sizes: {
      '-3': {
        fontSize: theme.sizes['-3']
      },
      '-2': {
        fontSize: theme.sizes['-2']
      },
      '-1': {
        fontSize: theme.sizes['-1']
      },
      '0': {
        fontSize: theme.sizes['0']
      },
      '1': {
        fontSize: theme.sizes['1']
      },
      '2': {
        fontSize: theme.sizes['2']
      },
      '3': {
        fontSize: theme.sizes['3']
      },
      '4': {
        fontSize: theme.sizes['4']
      },
      '5': {
        fontSize: theme.sizes['5']
      }
    }
  };
}
